import React from 'react';
import { calculaPrevision, formatMs, getControlById } from '../utils/time';

class ResultadosScrapeable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            time: 0
        };
    }

    componentDidMount() {
        this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    render() {
        const { resultados, sectores, controles, competicion } = this.props;

        const resultadosOrdenados = resultados
            .map((resultado) => {
                const prevision = calculaPrevision(competicion, controles, sectores, resultado);
                const controlUltimo = getControlById(controles, resultado.control_ultimo_id);

                const metaControl = controles.find(c => c.tipo === 'META');
                let tiempoMetaNeto = null;
                if (metaControl) {
                    const tiempoMeta = resultado['control_' + metaControl.id + '_tiempo'];
                    if (tiempoMeta) {
                        let tiempoInicioCorrector = 0;
                        if (competicion.tipo === 'TIEMPONETO' && resultado.start) {
                            tiempoInicioCorrector = resultado.start - (competicion.guntime || 0);
                        }
                        tiempoMetaNeto = tiempoMeta - tiempoInicioCorrector;
                    }
                }

                let tiempoEnCarrera = null;
                if (controlUltimo) {
                    const guntime = competicion.guntime || 0;
                    const [Y, M, D] = competicion.fecha_inicio.split('-').map(Number);
                    const fechaBase = new Date(Y, M - 1, D, 0, 0, 0, 0);
                    const ahora = this.state.time || Date.now();

                    let tiempoAhora = ahora - (fechaBase.getTime() + guntime);

                    if (resultado.guntime) {
                        tiempoAhora = ahora - (fechaBase.getTime() + resultado.guntime);
                    }

                    if (competicion.tipo === 'TIEMPONETO') {
                        tiempoAhora = resultado.start
                            ? ahora - (fechaBase.getTime() + resultado.start)
                            : ahora - (fechaBase.getTime() + guntime);
                    }

                    tiempoEnCarrera = tiempoAhora;
                }

                return { ...resultado, prevision, controlUltimo, tiempoEnCarrera, tiempoMetaNeto };
            })
            .sort((a, b) => {
                const getPrioridad = (r, meta) => {
                    if (r.descalificado) return 5;
                    if (r.retirado) return 4;
                    if (meta) return 1;
                    if (r.controlUltimo) return 2;
                    if (r.start) return 3;
                    return 6;
                };

                const pa = getPrioridad(a, a.tiempoMetaNeto);
                const pb = getPrioridad(b, b.tiempoMetaNeto);

                if (pa !== pb) return pa - pb;

                if (pa === 1) {
                    return a.tiempoMetaNeto - b.tiempoMetaNeto;
                }

                if (pa === 2) {
                    if (a.prevision.tiempoTotal && b.prevision.tiempoTotal) {
                        return a.prevision.tiempoTotal - b.prevision.tiempoTotal;
                    }
                    if (a.prevision.tiempoTotal) return -1;
                    if (b.prevision.tiempoTotal) return 1;
                }
                if (pa === 3) {
                    return (a.start || 0) - (b.start || 0);
                }

                return a.dorsal - b.dorsal;
            });

        let yaEmpezó = false;
        if (competicion.fecha_inicio && competicion.guntime) {
            const [Y, M, D] = competicion.fecha_inicio.split('-').map(Number);
            const fechaBase = new Date(Y, M - 1, D, 0, 0, 0, 0);
            const timestampGuntime = fechaBase.getTime() + competicion.guntime;
            yaEmpezó = Date.now() > timestampGuntime;
        }

        let posicionActual = 0;
        const posicionesPorDorsal = {};
        resultadosOrdenados.forEach((r) => {
            const metaControl = controles.find(c => c.tipo === 'META');
            const tiempoMeta = metaControl ? r['control_' + metaControl.id + '_tiempo'] : null;
            const control = r.controlUltimo;
            if (!r.descalificado && !r.retirado) {
                if (tiempoMeta || (control && r.tiempoEnCarrera)) {
                    posicionActual++;
                    posicionesPorDorsal[r.dorsal] = posicionActual;
                }
            }
        });

        const primerFinalizado = resultadosOrdenados.find(r =>
            r.tiempoMetaNeto && !r.descalificado && !r.retirado
        );

        return (
            <div className="scrapeable-container" style={{ 
                backgroundColor: '#0f172a', 
                color: '#fff', 
                minHeight: '100vh',
                padding: '20px',
                fontFamily: 'Montserrat, -apple-system, sans-serif'
            }}>
                <style>{`
                    body { margin: 0; background: #0f172a; }
                    .scrapeable-header {
                        text-align: center;
                        padding-bottom: 20px;
                        border-bottom: 2px solid #334155;
                        margin-bottom: 30px;
                    }
                    .scrapeable-title {
                        font-size: 2em;
                        margin-bottom: 10px;
                        font-weight: 700;
                    }
                    .scrapeable-subtitle {
                        color: #94a3b8;
                        font-size: 0.9em;
                    }
                    .scrapeable-list {
                        max-width: 1200px;
                        margin: 0 auto;
                    }
                    .scrapeable-item {
                        background: #1e293b;
                        border: 1px solid #334155;
                        border-radius: 8px;
                        padding: 15px;
                        margin-bottom: 12px;
                        display: flex;
                        align-items: center;
                        gap: 15px;
                    }
                    .scrapeable-posicion {
                        min-width: 50px;
                        height: 50px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #334155;
                        border: 1px solid #475569;
                        border-radius: 8px;
                        font-weight: bold;
                        font-size: 1.2em;
                    }
                    .scrapeable-info {
                        flex: 1;
                        min-width: 0;
                    }
                    .scrapeable-nombre {
                        font-size: 1.1em;
                        font-weight: 600;
                        margin-bottom: 5px;
                    }
                    .scrapeable-detalles {
                        font-size: 0.85em;
                        color: #94a3b8;
                    }
                    .scrapeable-tiempo {
                        text-align: right;
                        min-width: 120px;
                        font-family: 'Courier New', monospace;
                    }
                    .scrapeable-tiempo-valor {
                        font-size: 1.1em;
                        font-weight: bold;
                    }
                    .scrapeable-prevision {
                        color: #f87171;
                    }
                    .scrapeable-finalizado {
                        color: #fff;
                    }
                    .scrapeable-label {
                        font-size: 0.7em;
                        color: #94a3b8;
                        text-transform: uppercase;
                        letter-spacing: 1px;
                        margin-bottom: 3px;
                    }
                    .scrapeable-diferencia {
                        font-size: 0.85em;
                        color: #94a3b8;
                        margin-top: 3px;
                    }
                    .scrapeable-progreso {
                        margin-top: 10px;
                        height: 6px;
                        background: #334155;
                        border-radius: 3px;
                        overflow: hidden;
                        width: 100%;
                    }
                    .scrapeable-progreso-bar {
                        height: 100%;
                        background: #ef4444;
                        transition: width 0.3s;
                    }
                    .scrapeable-descalificado {
                        color: #fbbf24;
                    }
                    .scrapeable-retirado {
                        color: #f87171;
                    }
                    .scrapeable-footer {
                        text-align: center;
                        color: #64748b;
                        font-size: 0.8em;
                        margin-top: 30px;
                    }
                `}</style>

                <div className="scrapeable-header">
                    <h1 className="scrapeable-title">{competicion.nombre}</h1>
                    <div className="scrapeable-subtitle">
                        Resultados en tiempo real • Actualizado: {new Date().toLocaleString('es-ES')}
                    </div>
                </div>

                <div className="scrapeable-list">
                    {resultadosOrdenados.map((resultado) => {
                        const metaControl = controles.find(c => c.tipo === 'META');
                        const tiempoMeta = metaControl ? resultado['control_' + metaControl.id + '_tiempo'] : null;
                        const control = resultado.controlUltimo;

                        let estado = yaEmpezó ? 'NO PRESENTADO/SIN DATOS' : 'INSCRITO';
                        let tiempoMostrar = null;
                        let esPrevision = false;

                        if (resultado.descalificado) {
                            estado = 'DESCALIFICADO';
                        } else if (resultado.retirado) {
                            estado = 'RETIRADO';
                        } else if (tiempoMeta) {
                            estado = 'FINALIZADA';
                            tiempoMostrar = formatMs(resultado.tiempoMetaNeto);
                        } else if (control) {
                            estado = `En ${control.nombre}`;
                            if (resultado.prevision.tiempoTotal && !competicion.carrera_finalizada && controles.some(c => c.prevision)) {
                                tiempoMostrar = formatMs(resultado.prevision.tiempoTotal);
                                esPrevision = true;
                            }
                        } else if (resultado.start) {
                            estado = 'CON SALIDA';
                        }

                        const calcularDiferencia = () => {
                            if (!primerFinalizado || resultado.dorsal === primerFinalizado.dorsal || 
                                !primerFinalizado.tiempoMetaNeto || !resultado.tiempoMetaNeto) {
                                return null;
                            }

                            const redondear = (ms) => {
                                let s = Math.floor(ms / 1000);
                                if (ms % 1000 > 0) s++;
                                return s;
                            };

                            const segundosLider = redondear(primerFinalizado.tiempoMetaNeto);
                            const segundosActual = redondear(resultado.tiempoMetaNeto);
                            const difSegundos = segundosActual - segundosLider;

                            if (difSegundos === 0) return null;

                            const h = Math.floor(difSegundos / 3600);
                            const m = Math.floor((difSegundos % 3600) / 60);
                            const s = difSegundos % 60;
                            const z = (v, n) => String(v).padStart(n, '0');

                            return `+ ${z(h, 2)}:${z(m, 2)}:${z(s, 2)}`;
                        };

                        const diferencia = calcularDiferencia();

                        const puestoBadge = (resultado.descalificado || resultado.retirado)
                            ? '-'
                            : ((tiempoMeta || (control && resultado.tiempoEnCarrera))
                                ? posicionesPorDorsal[resultado.dorsal]
                                : '-');

                        return (
                            <div key={resultado.dorsal} className="scrapeable-item" data-dorsal={resultado.dorsal}>
                                <div className="scrapeable-posicion">
                                    {puestoBadge}
                                </div>

                                <div className="scrapeable-info">
                                    <div className="scrapeable-nombre">
                                        {resultado.nombre} {resultado.apellidos}
                                    </div>
                                    <div className="scrapeable-detalles">
                                        Dorsal <strong>{resultado.dorsal}</strong>
                                        {resultado.categoria_nombre && `, ${resultado.categoria_nombre}`}
                                        {resultado.clubNombre && `, ${resultado.clubNombre}`}
                                        <span style={{ color: '#fff', fontWeight: 500 }}> - {estado}</span>
                                    </div>
                                </div>

                                <div className="scrapeable-tiempo">
                                    {resultado.descalificado && (
                                        <div className="scrapeable-tiempo-valor scrapeable-descalificado">
                                            DESCALIFICADO
                                        </div>
                                    )}
                                    {resultado.retirado && (
                                        <div className="scrapeable-tiempo-valor scrapeable-retirado">
                                            RETIRADO
                                        </div>
                                    )}
                                    {!resultado.descalificado && !resultado.retirado && tiempoMostrar && (
                                        <>
                                            {esPrevision && <div className="scrapeable-label">PREVISIÓN</div>}
                                            <div className={`scrapeable-tiempo-valor ${esPrevision ? 'scrapeable-prevision' : 'scrapeable-finalizado'}`}>
                                                {tiempoMostrar}
                                            </div>
                                            {diferencia && (
                                                <div className="scrapeable-diferencia">{diferencia}</div>
                                            )}
                                        </>
                                    )}
                                    {!resultado.descalificado && !resultado.retirado && !tiempoMostrar && (
                                        <div className="scrapeable-tiempo-valor">---</div>
                                    )}
                                </div>

                                {!competicion.carrera_finalizada &&
                                    resultado.prevision.porcentaje !== null && controles.some(c => c.prevision) &&
                                    !resultado.descalificado &&
                                    !resultado.retirado &&
                                    !tiempoMeta && (
                                        <div style={{ width: '100%' }}>
                                            <div className="scrapeable-progreso">
                                                <div
                                                    className="scrapeable-progreso-bar"
                                                    style={{ width: `${resultado.prevision.porcentaje}%` }}
                                                />
                                            </div>
                                        </div>
                                    )}
                            </div>
                        );
                    })}
                </div>

                <div className="scrapeable-footer">
                    Datos actualizados en tiempo real desde CCN Timing
                </div>
            </div>
        );
    }
}

export default ResultadosScrapeable;